module.exports = __webpack_public_path__ + "static/media/event_type_arrow.e0a523ea.svg";